import {
  LOGIN_USER_SUCCESS,
  LOGOUT_USER,
  SET_DATE_LIST,
  CHANGE_USER_VIEW,
  GET_ONLINE_STATUS_SUCCESS,
  GET_EVENT_SUCCESS,
  GET_BANDWIDTH_USAGE_SUCCESS,
  SET_DEFAULT_USER_VIEW,
  SET_VIEW,
  UPDATE_CAMERAS_IN_VIEW,
  SAVE_VIEW,
} from '../actions/types';

const INITIAL_STATE = {
  customers: [],
  projects: [], // sites that belongs to the same customer that the logged in user is (JSUser.bCustomerID)
  devices: [], // devices that belongs to the same customer that the logged in user is (JSUser.bCustomerID)
  cameras: [], // cameras that belongs to the same customer that the logged in user is (JSUser.bCustomerID)
  deviceIdList: [],
  eventDateList: [],
  userViews: [], // views that the logged in user has access
  selectedUserView: {}, // currently selected view in the Live page
  defaultUserView: {}, // user's last selected view in Live page
  compositeCams: [], // this is a combination of the selected user view cams and the temporary cams that are waiting to be saved to the current user view
  popupMessages:  [],
  backendVersion: '',
  dir: ''
};

// eslint-disable-next-line
export default ( state = INITIAL_STATE, action ) => {
  switch ( action.type ) {
    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        dir: action.dir,
        backendVersion: action.backendVersion,
        customers: action.customers,
        projects: action.projects,
        devices: action.devices,
        cameras: action.cameras,
        deviceIdList: action.deviceIdList, // used to make auth calls to the backend
        userViews: action.userViews,
        defaultUserView: action.defaultUserView && action.defaultUserView.id?
                            action.defaultUserView :
                          action.userViews && action.userViews.length > 0 ?
                            action.userViews[0] :
                            {},
        selectedUserView: action.defaultUserView && action.defaultUserView.id  ?
                            action.defaultUserView:
                          action.userViews && action.userViews.length > 0 ?
                          action.userViews[0] :
                            {},
        compositeCams: action.defaultUserView && action.defaultUserView.id ?
                          action.defaultUserView.cams :
                       !action.userViews || action.userViews.length < 1 ?
                          [] :
                        action.userViews[0].cams ?
                        action.userViews[0].cams :
                        []
      }
    case LOGOUT_USER:
      return {
        ...state,
        customers: [],
        projects: [],
        devices: [],
        cameras: [],
        deviceIdList: [],
        eventDateList: [],
        userViews: [],
        selectedUserView: {},
        defaultUserView: {},
        compositeCams: [],
        popupMessages:  [],
        backendVersion: '',
        dir: ''
      }
    case GET_ONLINE_STATUS_SUCCESS:
      return {
        ...state,
        devices: action.devices,
        cameras: action.cameras
      }
    case GET_BANDWIDTH_USAGE_SUCCESS:
      // modify only data usage for each device
      //     bDataUsage: 8981007
      //     sDeviceID: "0242AC170004"
      let tempDevices = state.devices.slice();
      action.payload.forEach( (device) => {
        let targetDeviceIndex = tempDevices.findIndex( (tempDevice) => {  return tempDevice.sDeviceID === device.sDeviceID } );
        if ( targetDeviceIndex > -1 ) {
          tempDevices[targetDeviceIndex].bDataUsage = device.bDataUsage;
        };
      });

      return {
        ...state,
        devices: tempDevices
      }
    case GET_EVENT_SUCCESS:
      return {
        ...state,
        devices: action.devices,
        popupMessages: action.popupMessages
      }
    case SET_DATE_LIST:
      return {
        ...state,
        eventDateList: action.payload
      }
    case CHANGE_USER_VIEW:
      return {
        ...state,
        selectedUserView: action.selectedUserView,
        compositeCams: action.compositeCams
      }
    case SET_DEFAULT_USER_VIEW:
      return {
        ...state,
        defaultUserView: action.payload
      }
    case SET_VIEW:
      if (action.payload !== 'live') {
        const view = Object.keys(state.selectedUserView).length ? state.selectedUserView : state.defaultUserView
        return {
          ...state,
          compositeCams: view.cams,
          selectedUserView: view,
        }
      } else {
        return {
          ...state
        }
      }
    case UPDATE_CAMERAS_IN_VIEW:
      return {
        ...state,
        compositeCams: action.compositeCams,
      }   
    case SAVE_VIEW:
      return {
        ...state,
        compositeCams: action.compositeCams,
        selectedUserView: action.selectedUserView,
        defaultUserView: state.defaultUserView.id === action.selectedUserView.id ? action.selectedUserView : state.defaultUserView,
        userViews: action.userViews,
      }
    default:
      return state;
  };
};